module.exports = __webpack_public_path__ + "img/status_success_black-1.dbc866df.png";